export class LanguageModel {
  key: string;
  value: string;
}
